import { http } from "./Http";

// AM1701
export const GetPostalCodeListAPI = (config: any) => {
  const { baseURL, affiliate_cd, token } = config;
  const param = {
    token: token,
    url: `${baseURL}/v1/postal_codes/${affiliate_cd}`,
    config: config,
  };
  return http(param);
};
